export default {
  key: 'system--marketplace',
  // `/user/:slug` and `/u/:slug` are public-facing community profile
  // pages — same-origin navigation from the feed click stays on the
  // marketplace surface so we don't cross-domain to us-at.symbols.app.
  routes: [/^\/marketplace(\/|$)/, /^\/feed(\/|$)/, /^\/user\/[^/]+/, /^\/u\/[^/]+/],
  // `apps` is declared because the SEED CATALOG this surface renders lives in
  // the shared package and carries polyglot keys in its rows
  // (`apps.catalog.<id>.descr` — packages/shared/functions/marketplaceCatalog.js).
  // Without the namespace those 31 descriptions would resolve to nothing and
  // ship the raw dotted key to the card.
  // `account` is declared for the member-role names (`account.member.role.*`)
  // the App Store page's notify row reads (appStoreNotifyRoleKey): a role an
  // app may notify prints as its name in the viewer's language.
  i18nNamespaces: ['marketplace', 'apps', 'account'],
  app: () => import('./app.js').then((m) => m.default),
  context: () => import('./context.js').then((m) => m.default)
}
